/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TypeInputs */

const th_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภท`)
};

const en_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const ja_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種別`)
};

const zh_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const es_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const pt_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const id_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const fr_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const tl_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri`)
};

const vi_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

const ko_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유형`)
};

const de_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const ru_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const tr_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tür`)
};

const it_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const pl_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const uk_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const hi_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const ar_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const ms_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

const bn_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধরন`)
};

const zh_tw2_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const zh_hk2_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ur_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قسم`)
};

const fa_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گونه`)
};

const sw_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aina`)
};

const nl_type = /** @type {(inputs: TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soort`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {TypeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const type = /** @type {((inputs?: TypeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TypeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_type(inputs)
	if (locale === "ja") return ja_type(inputs)
	if (locale === "zh") return zh_type(inputs)
	if (locale === "es") return es_type(inputs)
	if (locale === "pt") return pt_type(inputs)
	if (locale === "id") return id_type(inputs)
	if (locale === "fr") return fr_type(inputs)
	if (locale === "tl") return tl_type(inputs)
	if (locale === "vi") return vi_type(inputs)
	if (locale === "ko") return ko_type(inputs)
	if (locale === "de") return de_type(inputs)
	if (locale === "ru") return ru_type(inputs)
	if (locale === "tr") return tr_type(inputs)
	if (locale === "it") return it_type(inputs)
	if (locale === "pl") return pl_type(inputs)
	if (locale === "uk") return uk_type(inputs)
	if (locale === "hi") return hi_type(inputs)
	if (locale === "ar") return ar_type(inputs)
	if (locale === "ms") return ms_type(inputs)
	if (locale === "bn") return bn_type(inputs)
	if (locale === "zh-TW") return zh_tw2_type(inputs)
	if (locale === "zh-HK") return zh_hk2_type(inputs)
	if (locale === "ur") return ur_type(inputs)
	if (locale === "fa") return fa_type(inputs)
	if (locale === "sw") return sw_type(inputs)
	if (locale === "nl") return nl_type(inputs)
	return en_type(inputs)
});